<template>
    <div v-show="show" class="dialog-container select">
        <div class="dialogContent">
            <img @click="close" class="close" src="./assets/close.png" alt="">
            <div class="title">审核流程配置</div>
            <div class="articlecontent">
                <div>
                    <p>当前栏目/账号：</p>
                    <p>{{config.title}}</p>
                </div>
                <div>
                    <p>配置审核流程：</p>
                    <ul>
                        <li @click="select(index)" v-for="(item,index) in list" :key="index">
                            <i :class="{on: item.selected}"></i>
                            <span>{{item.val}}</span>
                        </li>
                    </ul>
                </div>
                <div v-if="list && list.length >0 && list[0].selected">
                    <p style="color: transparent">配置审核流程：</p>
                    <span style="font-size: 14px;color: #666666">文稿将在编辑提交后直接发布</span>
                </div>
            </div>
            <div class="btn">
                <p @click="confirm" class="g">确定</p>
                <p @click="close">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    watch: {
        content(to) {
            this.num = to.length;
        }
    },
    data() {
        return {
            saveIndex: 0,
            list: [],
            placeholder: '',
            show: false,
            config: {},
            callback: null,
            title: '退回理由',
            canEdit: true,
            maxLength: 100,
            num: 0,
            content: '',
            singleBtn: false,
            errTitle: '退回理由不能为空'
        }
    },
    methods: {
        select(index) {
            let list = this.list;
            list.forEach(el => {
                el.selected = false
            })

            list[index].selected = true;
            this.list = list
        },
        open(config, callback) {
            this.config = config;
            this.callback = callback;
            config.processList.forEach((el,index) => {
                if(el.selected){
                    this.saveIndex = index
                }
            })
            this.list = config.processList
            this.show = true;
        },
        confirm() {
            let nowIndex = 0
            this.list.forEach((el,index) => {
                if(el.selected){
                    nowIndex = index
                }
            })

            console.log(nowIndex,this.saveIndex)

            if(nowIndex < this.saveIndex){
                let showVal = ''
                if(nowIndex == 0 && this.saveIndex == 3){
                    showVal = this.list[1].val + ',' + this.list[2].val + ',' + this.list[3].val
                }else if(nowIndex == 0 && this.saveIndex == 2){
                    showVal = this.list[1].val + ',' + this.list[2].val
                }else if(nowIndex == 1 && this.saveIndex == 3){
                    showVal = this.list[2].val + ',' + this.list[3].val
                }else{
                    showVal = this.list[this.saveIndex].val
                }

                let config1 = {
                    title: '温馨提示',
                    content: '当前审核流程更改会导致<em>'+showVal+'</em>用户被删除，是否确定操作？',
                    btn1: '是',
                    btn2: '否',
                    showIcon: false,
                    showAlert: false
                }

                this.$MediaPlatformNotify(config1).then(e => {
                    // console.log(e)
                    if(e){
                        this.show = false;
                        this.callback(this.list)
                    }
                })
            }else{
                this.show = false;
                this.callback(this.list)
            }
            
        },
        cancel() {
            this.show = false;
            this.callback(false)
        },
        close() {
            this.cancel()
        }
    }
}
</script>

<style lang="less">
    .dialog-container.select {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1001;
        background-color: rgba(50, 59, 75, 0.3);
        backdrop-filter: blur(1.6px);

        .dialogContent {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            // align-items: center;
            position: absolute;
            top: 50%;
            left: 50%;
            width: 702px;
            height: 292px;
            border-radius: 4px;
            display: flex;
            flex-direction: column;
            margin-left: -351px;
            margin-top: -146px;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
            padding: 40px 100px 40px;
            box-sizing: border-box;

            .close {
                position: absolute;
                top: 20px;
                right: 30px;
                width: 21px;
                height: 21px;
                user-select: none;
                cursor: pointer;
            }

            .title {
                font-size: 20px;
                line-height: 28px;
                color: #050F0F;
                font-weight: bold;
            }

            .articlecontent {
                display: flex;
                flex-direction: column;

                div {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    margin-bottom: 18px;

                    p {
                        font-size: 14px;
                        line-height: 20px;
                        color: #050F0F;
                        margin-right: 10px;
                        font-weight: bold;

                        &:nth-of-type(2) {
                            margin-right: 0;
                        }
                    }

                    ul {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        li {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            margin-right: 50px;

                            &:nth-last-of-type(1) {
                                margin-right: 0;
                            }

                            i {
                                display: block;
                                width: 16px;
                                height: 16px;
                                border-radius: 8px;
                                border: 1px solid #B9C3C3;
                                box-sizing: border-box;
                                margin-right: 10px;

                                &.on {
                                    position: relative;
                                    background: #41B48C;
                                    border: 1px solid #41B48C;
                                    box-sizing: border-box;

                                    &:after {
                                        position: absolute;
                                        top: 50%;
                                        left: 50%;
                                        margin-left: -3px;
                                        margin-top: -3px;
                                        display: block;
                                        content: '';
                                        width: 6px;
                                        height: 6px;
                                        background: #FFFFFF;
                                        border-radius: 20px;
                                    }
                                }
                            }

                            span {
                                font-size: 14px;
                                color: #050F0F;
                                font-weight: bold;
                            }
                        }
                    }
                }
            }

            .btn {
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 100%;

                p {
                    width: 120px;
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    background: #B9C3C3;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #FFF;
                    font-weight: bold;
                    user-select: none;
                    cursor: pointer;

                    &.g {
                        background: #41B48C;
                        margin-right: 20px;
                    }
                }
            }
        }
    }
</style>